import { map } from 'ramda';

function bindActionCreators(dispatch, actionCreators) {
  return map((actionCreator) => {
    return (...args) => dispatch(actionCreator(...args));
  }, actionCreators);
};

function bindSelectors(store, selectors) {
  return map((selector) => {
    return (...args) => selector(store, ...args);
  }, selectors);
};

/**
 * Iterate over modules,
 */
export default function bindActionCreatorsAndSelectors(store, modules) {
  return map((module) => {
    return Object.assign({},
      bindActionCreators(store.dispatch, module.actions),
      bindSelectors(store, module.selectors)
    );
  }, modules);
};



// WEBPACK FOOTER //
// ./src/store/bindActionCreatorsAndSelectors.js